import { withInstall } from '@jdesign-vue/utils'

import Input from './src/input.vue'

export const JdInput = withInstall(Input)
export default JdInput

export * from './src/input'
export type { InputInstance } from './src/instance'
